import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { IRespostaQuerys } from '../modelos/IQuery';
import { get, post, patch, del } from "../../api/api";

export const listarTodasQuerys = async (params?: { versao?: string; erpId?: string; versaoId?: string }) => {
  const hasParams = params && Object.values(params).some(Boolean);
  return await get<IRespostaFuncao<any[]>>('/querys', hasParams ? { params } : undefined);
};

export const listarQuerys = async (erpId: string, versaoId: string) => {
  return await get<IRespostaFuncao<IRespostaQuerys>>(`/querys/erp/${erpId}/versao/${versaoId}`);
};

export const criarQuery = async (payload: {
  nome: string;
  erpId: string;
  versaoId: string;
  sql: string;
  source?: string;
  variaveis?: string[];
}) => {
  return await post<IRespostaFuncao<any>>('/querys/cria-query', payload);
};

export const atualizarQuery = async (id: string, payload: {
  nome?: string;
  erpId?: string;
  versaoId?: string;
  sql?: string;
  source?: string;
  variaveis?: string[];
}) => {
  return await patch<IRespostaFuncao<any>>(`/querys/${id}/atualiza-query`, payload);
};

export const removerQuery = async (id: string) => {
  return await del<IRespostaFuncao<any>>(`/querys/${id}/remove-query`);
};
